import { useParam } from "@blitzjs/next"
import { useQuery } from "@blitzjs/rpc"
import { createContext, FC, PropsWithChildren, useEffect, useState } from "react"
import getOnboardingContext from "./queries/getOnboardingContext"

export type OnboardingStore = {
  sdkInstalled: boolean // installed the SDK // checks for an app_open event
  paywallPresented: boolean // checks for a paywall_open event
  productsCreated: boolean // added in settings
  productsAddedToPaywall: boolean // added to example paywall
  transactionCompleted: boolean // has a transaction complete event
  onboardingCompleted: boolean // should display onboarding card
  isReady: boolean // all queries have loaded
  revenueTrackingEnabled: boolean
}

const defaultOnboardingStore: OnboardingStore = {
  sdkInstalled: false,
  paywallPresented: false,
  productsCreated: false,
  productsAddedToPaywall: false,
  transactionCompleted: false,
  onboardingCompleted: false,
  revenueTrackingEnabled: false,
  isReady: false,
}

export const OnboardingContext = createContext<OnboardingStore>(defaultOnboardingStore)

export const OnboardingProgressProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const applicationId = useParam("applicationId", "number")!

  const [onboardingState, setOnboardingState] = useState<OnboardingStore>(defaultOnboardingStore)

  const [_onboardingState] = useQuery(
    getOnboardingContext,
    {
      applicationId,
    },
    {
      enabled: !!applicationId,
      suspense: false,
    }
  )

  useEffect(() => {
    if (!_onboardingState) return
    setOnboardingState({ ..._onboardingState, isReady: true })
  }, [_onboardingState])

  return <OnboardingContext.Provider value={onboardingState}>{children}</OnboardingContext.Provider>
}

export default OnboardingProgressProvider
